export const VALIDATION_IDS = {
  DISABILITY_DATE_RANGE: 'disability-expense-date-range',
  CHILD_CARE_SCHOOL_LOOK_FOR_WORK_DATE_RANGE: 'child-care-school-look-for-work-expense-date-range',
  CHILD_CARE_WORK_DATE_RANGE: 'child-care-work-expense-date-range',
  // Add more validation IDs here
} as const;

export const VALIDATION_TYPES = {
  DATE_RANGE: 'dateRange',
  VERIFICATION_FAILED: 'verificationFailed',
  // Add more validation types here
} as const;

export const VALIDATION_MESSAGES = {
  DISABILITY_DATE_RANGE:
    'Disability expense dates must fall within the range of at least one source of Income.',
  CHILD_CARE_SCHOOL_LOOK_FOR_WORK_DATE_RANGE:
    'Child Care School or Look for Work expense dates must fall within the range of at least one Unemployment or Other Non Wage Source income.',
  CHILD_CARE_WORK_DATE_RANGE:
    'Child Care Work expense dates must fall within the range of at least one source of Income.',
  // Add more messages here
  VERIFICATION_FAILED_APPLICATION_CANT_BE_COMPLETED:
    'ID or Income verification has failed and application completion is not allowed.',
  WAIT_FOR_VERIFICATION_TO_COMPLETE: 'Please wait for ID or Income verification to complete.',
} as const;
